import { render, staticRenderFns } from "./LkBurgerBtn.vue?vue&type=template&id=21e2389c&"
import script from "./LkBurgerBtn.vue?vue&type=script&lang=js&"
export * from "./LkBurgerBtn.vue?vue&type=script&lang=js&"
import style0 from "./LkBurgerBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkBurgerBtn.vue
// module id = 1593
// module chunks = 0